import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import UploadAsset from './UploadAsset';
import { useState } from 'react';

const useStyles = makeStyles({
    button: {
        marginBottom: 10,
        marginRight: '12%'
    },
    textCapitalise: {
        textTransform: 'capitalize'
    }
})

export default function CreateAssetButton() {

    const classes = useStyles();
    const [openAssetUploadModal, setOpenAssetUploadModal] = useState(false);

    const openUpload = () => {
        setOpenAssetUploadModal(true);
    }

    return (
        <>
            <Button onClick={openUpload} variant={'contained'} color={'primary'} className={classes.textCapitalise} data-ui-tour-id="asset-create-btn">Upload asset</Button>
            {openAssetUploadModal && <UploadAsset parent={null} onClose={() => setOpenAssetUploadModal(false)} />}
        </>
    )
}